'use strict';
var globalThis = require('../internals/global-this');

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/environment-user-agent.js
// module id = 1390
// module chunks = 0